<template>
  <div>
    <div class="container-fluid">
      <div data-widget-group="group1">
        <ol class="breadcrumb">
          <li class="active">
            <router-link to="/admin">Dashboard</router-link>
          </li>
          <li class="active"><a href="#">Redeemption Request List</a></li>
        </ol>
        <div class="panel-body locationform">
          <div v-if="ErrorMessage" class="alert-danger alert visibility" role="alert">
            {{ ErrorMessage }}
          </div>
          <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
            {{ SuccessMessage }}
          </div>

          <div class="row ">
            <div class="col-md-12">
              <div class="col-md-3">
                <div id="search-box">
                  <div class="form-group">
                    <input type="text" class="search-query form-control" placeholder="Search" v-model="searchText" />
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <button type="button" v-on:click="getUserList(1)" class="btn btn-raised btn-primary submitbtn">
                    Search
                  </button>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <button class="btn btn-danger submitbtn btn-raised pull-right" @click="AllApproveFunction">Approve
                    All</button>
                </div>
              </div>

            </div>
            <div class="col-md-12 ">
              <table class="table table-striped table-bordered" cellspacing="0" width="100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer Code</th>
                    <th>Shop Name</th>

                    <th>Redeemption Points</th>
                    <th>Partner Type</th>
                    <th>Approval Status</th>
                    <th>Last Update On</th>
                    <th>Redeemption Date</th>
                    <th v-if="$can('Edit', 'Loyalty::Redeemption Approval')">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr class="odd gradeX"> -->
                  <tr v-for="(item, index) in customer_redeem_data" :key="item.id" class="gradeC">
                    <td>{{ currentPage * pageSize + index + 1 }}</td>
                    <td>{{ item.UserCode }}</td>
                    <td>{{ item.ShopName }}</td>
                    <td>{{ item.RedeemptionPoints }}</td>
                    <td>{{ item.PartnerType }}</td>
                    <td>{{ item.ReedemptionStatus }}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                    <td>{{ item.created_date | dateFormatReadable }}</td>
                    <td v-if="$can('Edit', 'Loyalty::Redeemption Approval')">
                      <a @click="ApproveFunction(item.UserCode)" href="#">Approve</a> &nbsp;
                      <a @click="RejectFunction(item.UserCode)" href="#">Reject</a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-md-12">
                <paginate :page-count="TotalPage" :click-handler="getUserList" :prev-text="'Prev'" :next-text="'Next'"
                  :container-class="'pagination'">
                </paginate>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate';

import commonServices from '../services/common-services';
import moment from 'moment';
import UserService from '../services/user.service';
function initialState() {
  return {
    batch_code: '',
    product_id: '',
  };
}
export default {
  name: 'redeemptionRequestList',
  data() {
    return {
      searchText: '',
      customer_redeem_data: [],
      page: 1,
      pageSize: 10,
      TotalPage: 1,
      currentPage: '',
      ErrorMessage: '',
      SuccessMessage: '',
      productSelected: '',
      loading: false,

    };
  },
  components: {

    Paginate
  },
  beforeCreate() {
    this.$store.commit('SET_LAYOUT', 'app-layout');
  },
  methods: {
    AllApproveFunction() {
      if (!confirm('Do you want to approve all the entries of this page ?')) { return; }
      let loader = this.$loading.show();
      let data = {},r=1;
      this.customer_redeem_data.forEach(item => {
        setTimeout(function(){ 

        data['status'] = "AcceptRequest";
        data['UserCode'] = item.UserCode;
        commonServices.put('kspgAPI/Loyalty/reedemAction', data)
          .then((responce) => {
            this.SuccessMessage = responce.data.message;
            if (responce.data.status) {
              loader.hide()
              this.getUserList(1);
            }
          },
            (error) => {
              loader.hide()
              //   this.loading = false;
              this.ErrorMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          )
          .catch((e) => {
            if (e.response.data.error == "Invalid API key ") {
              loader.hide()
              this.$router.push({ name: 'login' });
            }
          });

          }, 300*r);
          r++;
      });

      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
      setTimeout(() => (location.reload()), 6000);
    },
    ApproveFunction(UserCode) {
      if (!confirm('Do you want to continue ?')) { return; }
      let loader = this.$loading.show();
      let data = {};
      data['status'] = "AcceptRequest";
      data['UserCode'] = UserCode;
      commonServices.put('kspgAPI/Loyalty/reedemAction', data)
        .then((responce) => {
          this.SuccessMessage = responce.data.message;
          if (responce.data.status) {
            loader.hide()
            this.getUserList(1);
          }
        },
          (error) => {
            loader.hide()
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          if (e.response.data.error == "Invalid API key ") {
            loader.hide()
            this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    RejectFunction(UserCode) {
      if (!confirm('Do you want to continue ?')) { return; }
      let loader = this.$loading.show();
      let data = {};
      data['status'] = "RejectRequest";
      data['UserCode'] = UserCode;
      commonServices.put('kspgAPI/Loyalty/reedemAction', data)
        .then((responce) => {
          this.SuccessMessage = responce.data.message;
          if (responce.data.status) {
            loader.hide()
            this.getUserList(1);
          }
        },
          (error) => {
            loader.hide()
            //   this.loading = false;
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
          }
        )
        .catch((e) => {
          if (e.response.data.error == "Invalid API key ") {
            loader.hide()
            this.$router.push({ name: 'login' });
          }
        });
      setTimeout(() => (this.SuccessMessage = false), 5000);
      setTimeout(() => (this.ErrorMessage = false), 5000);
    },
    getRequestParams(searchText, page, pageSize) {
      let params = {};

      if (searchText) {
        params['searchText'] = searchText;
      }

      if (page) {
        params['page'] = page - 1;
      }

      if (pageSize) {
        params['size'] = pageSize;
      }

      return params;
    },
    getUserList(pageNum) {

      this.skyloStart();
      let loader = this.$loading.show();
      const params = this.getRequestParams(
        this.searchText,
        pageNum,
        this.pageSize
      );
      UserService.getMetod('kspgAPI/Loyalty/list', params).then((response) => {
        const {
          customer_redeem_data,
          totalItems,
          currentPage,
          TotalPage,
        } = response.data;
        this.customer_redeem_data = customer_redeem_data;
        this.TotalPage = TotalPage;
        this.currentPage = parseInt(currentPage);

      });
      this.skyloEnd();
      setTimeout(() => { loader.hide() }, 1000)
      setTimeout(() => (this.SuccessMessage = false), 7000);
      setTimeout(() => (this.ErrorMessage = false), 7000);
    },


  },
  created() { },
  mounted() { this.getUserList(1); },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
  filters: {
    dateFormatReadable(input_date) {
      if (!input_date) {
        return input_date;
      }
      return moment(String(input_date)).format('DD-MM-YYYY');
    },
  },
};
</script>
<style scoped>
.visibility {
  visibility: visible !important;
}
</style>
